(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["globo-custom"] && !Shopify.designMode) return;
  try {
    function initImageSkeleton() {
  document.querySelectorAll('.skeleton-target').forEach(img => {
    if (img.dataset.skeletonBound) return;
    img.dataset.skeletonBound = true;

    const wrapper = img.closest('.spf-product-card__image-wrapper');
    const skeleton = wrapper?.querySelector('.image-skeleton');

    function done() {
      img.classList.add('loaded');
      if (skeleton) skeleton.remove();
    }

    if (img.complete) {
      done();
    } else {
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    }
  });
}

initImageSkeleton();

window.addEventListener("globoFilterRenderCompleted", function () {
  setTimeout(initImageSkeleton, 200);
});
  } catch(e) { console.error(e); }
})();

})();
